import { useMutation, useQueryClient } from '@tanstack/react-query'

import { reportError } from '@/domains/observability'

import { markAllNotificationsRead } from './api'

/** shared mutation for the mark-all-read action. used by the /notifications
 * page header button and the command-palette "Mark all as read" item so
 * both surfaces stay in lockstep (error reporting + cache invalidation).
 */
export function useMarkAllRead() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: markAllNotificationsRead,
    onError: reportError,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['notifications'] })
    }
  })
}
